import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetProductStoreByIdResponse,
  GetProductStoreResponse,
  PostProductStoreResponse,
  PutProductStoreResponse,
} from '../response/product-store';
import { PostProductStoreRequest, PutProductStoreRequest } from '../request/product-store';

export class ProductStoreService {
  static getProductStores(params?: QueryParams) {
    return apiClient.get<GetProductStoreResponse>(buildApiUrl('/api/v1/media/product'), params);
  }

  static postProductStore(data: PostProductStoreRequest) {
    return apiClient.createWithFile<PostProductStoreResponse>(buildApiUrl('/api/v1/media/product'), data);
  }

  static getProductStoreById(id: string) {
    const url = buildApiUrl('/api/v1/media/product/:id', { id });
    return apiClient.get<GetProductStoreByIdResponse>(url, undefined);
  }

  static putProductStore(id: string, data: PutProductStoreRequest) {
    const url = buildApiUrl('/api/v1/media/product/:id', { id });
    return apiClient.updateWithFile<PutProductStoreResponse>(url, data);
  }

  static deleteProductStore(id: string) {
    const url = buildApiUrl('/api/v1/media/product/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }
}
